import React, { useRef } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';
import { User, MessageCircle, Sparkles, Filter, Database, Calendar, CalendarCheck, RefreshCw } from 'lucide-react';
const nodes = [{
  label: 'Visitante',
  icon: User
}, {
  label: 'WhatsApp',
  icon: MessageCircle
}, {
  label: 'IA',
  icon: Sparkles
}, {
  label: 'Calificación',
  icon: Filter
}, {
  label: 'CRM',
  icon: Database
}, {
  label: 'Agenda',
  icon: Calendar
}, {
  label: 'Cita',
  icon: CalendarCheck
}, {
  label: 'Seguimiento',
  icon: RefreshCw
}];
export function SystemFlow() {
  const containerRef = useRef<HTMLDivElement>(null);
  const rawRotateX = useMotionValue(0);
  const rawRotateY = useMotionValue(0);
  const rotateX = useSpring(rawRotateX, {
    stiffness: 150,
    damping: 20
  });
  const rotateY = useSpring(rawRotateY, {
    stiffness: 150,
    damping: 20
  });
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;
    const px = (e.clientX - rect.left) / rect.width - 0.5;
    const py = (e.clientY - rect.top) / rect.height - 0.5;
    rawRotateY.set(px * 8);
    rawRotateX.set(py * -8);
  };
  const handleMouseLeave = () => {
    rawRotateX.set(0);
    rawRotateY.set(0);
  };
  return <div ref={containerRef} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} style={{
    perspective: 1200
  }} className="relative w-full max-w-[360px] mx-auto" data-id="element-315" data-mp="1olfyrp2wdg3s">
      <motion.div style={{
      rotateX,
      rotateY
    }} className="relative flex flex-col gap-3 py-2" data-id="element-316" data-mp="2hadfhnrgn4uf">
        <div aria-hidden="true" className="absolute left-[26px] top-[24px] bottom-[24px] w-px bg-carbon/10" data-id="element-317" data-mp="2c8o1q0cusd2n">
          <div className="system-flow-pulse absolute left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-azul" data-id="element-318" data-mp="10v2eikqk0ljr" />
        </div>

        {nodes.map((node, idx) => {
        const Icon = node.icon;
        return <motion.div key={node.label} initial={{
          opacity: 0,
          x: 16,
          rotate: 0
        }} whileInView={{
          opacity: 1,
          x: 0,
          rotate: idx % 2 === 0 ? -1 : 1
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: idx * 0.06
        }} className="relative z-10 flex items-center gap-3 bg-arena border border-carbon/10 rounded-[12px] pl-2.5 pr-4 py-2.5 shadow-card" data-id="element-319" data-mp="3k1eggzuto1tc" data-mpi={idx}>
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-verde/10 text-verde flex-shrink-0" data-id="element-320" data-mp="2wd52ul7rikda">
                <Icon size={15} strokeWidth={2} data-id="element-321" data-mp="2hfurrcz17gi3" />
              </span>
              <span className="font-body text-[13px] font-medium text-carbon" data-id="element-322" data-mp="2md4g0paopm4c">
                {node.label}
              </span>
            </motion.div>;
      })}
      </motion.div>
    </div>;
}